'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _filterShape = require('./filterShape');

var _filterShape2 = _interopRequireDefault(_filterShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchFieldShape = _react.PropTypes.shape({
  id: _react.PropTypes.string,
  hasMore: _react.PropTypes.bool,
  fieldFilters: _react.PropTypes.arrayOf(_filterShape2.default)
});

exports.default = searchFieldShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/searchFieldShape.js
// module id = 362
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15